export const SPACE_METADATA_TEXT_FIELD_KEYS = {
    motto: 'motto',
    aboutTown: 'about-town',
    aboutCreator: 'about-creator',
    creatorDisplayName: 'creator-display-name',
    features: 'features',
    socialLinks: 'social-links',
} as const
